export const addHelp = () => {
  const helps = document.querySelectorAll('.price-roi__help')
  for (let i = 0; i < helps.length; i++) {
    const help = helps[i]

    const cnt = help.querySelector<HTMLElement>('.price-roi__help-cnt')
    help.addEventListener('click', () => {
      cnt.classList.add('active')
    })

    const overlay = help.querySelector('.price-roi__help-overlay')
    overlay.addEventListener('click', (e: MouseEvent) => {
      e.stopPropagation()
      cnt.classList.remove('active')
    })
  }
}
